// extracted by mini-css-extract-plugin
module.exports = {"tab":"a10a3f92e9--tab--AtfZp","active":"a10a3f92e9--active--bAns6","focus-visible":"a10a3f92e9--focus-visible--hxn9c","text":"a10a3f92e9--text--uR2tg"};